import type { ComponentType } from 'react';

import { BankAccountSelector } from 'features/profile/components/bank-account-selector';
import { BankSelectorField } from 'features/profile/components/bank-selector-field';
import { PSPSelector } from 'features/gateways/components/psp-selector';

/*
 * Field components for the generic search form that live inside a feature.
 * The search form itself must stay free of feature imports, so the wiring
 * happens here at the application layer.
 */
export const searchFieldComponents: Record<string, ComponentType<any>> = {
    BankAccount: BankAccountSelector,
    Bank: BankSelectorField,
    PSP: PSPSelector,
};
